module.exports = __webpack_public_path__ + "static/media/62.0ded85c5.jpg";